import { footer, site } from "../lib/content";
import SmartLink from "./SmartLink";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-ink-line bg-white">
      <div className="container-page py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <SmartLink href="/" ariaLabel={`${site.name} home`}>
              <img src="/qostlogo.png" alt={site.name} className="h-8 w-auto" />
            </SmartLink>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink-muted">
              {footer.blurb}
            </p>
            <SmartLink
              href={site.cloudlayaUrl}
              className="mt-6 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-ink-muted transition-colors hover:text-brand-600"
            >
              A product of Cloudlaya
            </SmartLink>
          </div>

          {footer.columns.map((column) => (
            <div key={column.title}>
              <h2 className="text-xs font-semibold uppercase tracking-[0.16em] text-ink">
                {column.title}
              </h2>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <SmartLink
                      href={link.href}
                      className="text-sm text-ink-muted transition-colors hover:text-brand-600"
                    >
                      {link.label}
                    </SmartLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-ink-line pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-ink-muted">
            © {year} {site.name} — a product of Cloudlaya, Inc. All rights reserved.
          </p>
          <p className="flex items-center gap-5 text-xs">
            <SmartLink
              href="/privacy"
              className="text-ink-muted transition-colors hover:text-brand-600"
            >
              Privacy Policy
            </SmartLink>
            <SmartLink
              href="/terms"
              className="text-ink-muted transition-colors hover:text-brand-600"
            >
              Terms of Service
            </SmartLink>
          </p>
        </div>
      </div>
    </footer>
  );
}
